import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnFilterClickNote(props) {
  let current = useDataValue({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (current.length === 0) {
      change(['note'])
      return
    }

    if (current.includes('note')) {
      let newSelected = current.filter(item => item !== 'note')
      change(newSelected)
    } else {
      change([...current, 'note'])
    }
  }
}

export function getCount(transactions, type) {
  return transactions.filter(item => item.type === type).length
}
